<script setup>
import { useCalendarViewState } from '../composables/useCalendarViewState'

const props = defineProps({
  event: {
    type: Object,
    default: undefined,
  },
})

const view = useCalendarViewState()
const isListView = computed(() => view.value === 'day')
</script>

<template>
  <ScheduleEventItemList
    v-if="isListView"
    :event="props.event"
  />
  <ScheduleEventItemGrid
    v-else
    :event="props.event"
  />
</template>
